import { memo } from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CatalogItemPriceRow } from "../catalogItemPrices.types";

export function getCatalogItemPriceStatusLabel(
    price: CatalogItemPriceRow,
): string | null {
    if (price.isDraft || price.isStaged) {
        return null;
    }
    if (price.isDefault || price.isLastActive) {
        return "Default";
    }
    if (!price.active) {
        return "Archived";
    }
    return "Active";
}

export const PriceStatusCell = memo(function PriceStatusCell({
    row,
}: CellContext<ViewTableFeatures, CatalogItemPriceRow, unknown>) {
    const label = getCatalogItemPriceStatusLabel(row.original);
    return <ViewTableCell>{label}</ViewTableCell>;
});
